import { Icon, LinkWithButtonStyles } from '@frontendmentorio/design-system-v2';

export default function ProLockMessage({ children, withCTA }) {
  return (
    <div className="bg-gray-100 flex flex-wrap gap-3 justify-end p-5 rounded-xl">
      <div className="flex gap-4 items-center text-start">
        <Icon className="text-blue-500 text-xl" name="gem" />

        <div>{children}</div>
      </div>

      {withCTA && (
        <LinkWithButtonStyles href="/pro">Unlock Pro</LinkWithButtonStyles>
      )}
    </div>
  );
}
